import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ProjectDetail from "./pages/projects/ProjectDetail";
import Projects from "./pages/projects/Project";

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetail />} />
    </Routes>
  );
};

export default App;
